<template>
  <path d="M912,512c0,220.91-179.09,400-400,400S112,732.91,112,512,291.09,112,512,112,912,291.09,912,512Z" style="fill:#fff;opacity:0.02"/><path d="M512,27C243.59,27,27,245.14,27,513S243.59,997,512,997,997,780.86,997,513,780.41,27,512,27Zm0,880c-218.6,0-394.81-175.85-394.81-394S293.4,117,512,117,906.81,294.85,906.81,513,730.6,907,512,907Z" /><path d="M525.34,428.74l69.2-127.27a15,15,0,0,1,13.18-7.83H682.1A15,15,0,0,1,695,316.24L578.21,515.16a15,15,0,0,0,0,15.24L698.37,733.1a15,15,0,0,1-12.9,22.65H609.9A15,15,0,0,1,596.75,748L525.31,617.83a15,15,0,0,0-26.3,0L427.56,748a15,15,0,0,1-13.14,7.78H338.85A15,15,0,0,1,326,733.1L446.08,530.4a15,15,0,0,0,0-15.24L329.29,316.24a15,15,0,0,1,12.93-22.6H416.6a15,15,0,0,1,13.17,7.83L499,428.74A15,15,0,0,0,525.34,428.74Z"/>
</template>

<script>
export default {
  name: "IconHelp"
}
</script>
